import { useEffect, useState } from "react";
import { Typography } from "@material-ui/core";
import DialogModal from "../components/UI/DialogModals";
import InstallmentsTable from "../components/shared/Installments/Table";
import InstallmentsPageHeader from "../components/shared/Installments/InstallmentsPageHeader";
import DiscountForm from "../components/Discounts/DiscountsForm";

import { DiscountStore as Store, DiscountTableStore } from "../store";
import { lang } from "../i18nLang";

const Discounts = () => {
  const [open, setOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);

  useEffect(() => {
    Store.addDiscountsObserver();

    return () => {
      Store.removeObserver();
    };
  }, []);

  const handleCloseForm = () => setOpen(false);
  const handleCloseDelete = () => setOpenDelete(false);

  const handleClickOpenForm = () => {
    Store.clearCurrentDiscount();
    setOpen(true);
  };

  const handleClickEdit = (id) => {
    Store.setCurrentDiscount(id);
    setOpen(true);
  };

  const handleClickDelete = (id) => {
    Store.setCurrentDiscount(id);
    setOpenDelete(true);
  };

  const handleConfirmDelete = () => {
    Store.deleteDiscount();
  };

  const handleChangeDate = (id, installmentId, newDate) => {
    Store.setCurrentDiscount(id);
    Store.updateInstallmentMaturityDate(installmentId, newDate);
  };

  return (
    <>
      <InstallmentsPageHeader
        title={lang("discounts.title")}
        newButtonLabel={lang("discounts.new")}
        onNewData={handleClickOpenForm}
        totals={[
          {
            label: lang("discounts.billingTotal"),
            value: Store.discountsTotalToBill,
          },
          {
            label: lang("discounts.amount"),
            value: Store.discountsTotal,
          },
        ]}
      />
      <InstallmentsTable
        store={DiscountTableStore}
        onEditRowData={handleClickEdit}
        onDeleteRowData={handleClickDelete}
        onEditMaturityDate={handleChangeDate}
      />
      <DiscountForm open={open} onClose={handleCloseForm} />
      <DialogModal
        title={lang("discounts.deleteModal.title")}
        open={openDelete}
        onClose={handleCloseDelete}
        onConfirm={handleConfirmDelete}
        confirmLabel={lang("delete")}
      >
        <Typography variant="body1">
          {lang("discounts.deleteModal.text")}
        </Typography>
      </DialogModal>
    </>
  );
};

export default Discounts;
